import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { LegalityContent } from "./LegalityContent";
import { QsoilLegalityContent } from "./QsoilLegalityContent";
import { LegalityScreens } from "../../common/types/enums";
import styles from "./LegalityScreen.module.scss";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import { useTheme } from "../../common/hooks/useTheme";
import { selectCurrentCluster } from "../../store/slices/currentClusterSlice";

export const LegalityScreen = () => {
  const location = useLocation();
  const { theme } = useTheme();
  const cluster = useSelector(selectCurrentCluster);

  const getScreenFromPath = (): LegalityScreens => {
    const path = location.pathname;

    if (path.includes("privacy")) {
      return LegalityScreens.PRIVACY_POLICY;
    }
    if (path.includes("personal-data")) {
      return LegalityScreens.PERSONAL_DATA_AGREEMENT;
    }
    if (path.includes("cookie")) {
      return LegalityScreens.COOKIE_POLICY;
    }
    return LegalityScreens.USER_AGREEMENT;
  };

  const getTitle = () => {
    switch (getScreenFromPath()) {
      case LegalityScreens.PRIVACY_POLICY:
        return "Политика конфиденциальности";
      case LegalityScreens.PERSONAL_DATA_AGREEMENT:
        return "Согласие на обработку данных";
      case LegalityScreens.COOKIE_POLICY:
        return "Политика использования cookie";
      default:
        return "Пользовательское соглашение";
    }
  };

  const currentScreen = getScreenFromPath();
  const isQsoil = cluster?.id === 7;

  return (
    <div className={styles.page} style={{ backgroundColor: theme.background }}>
      <ProductHeader
        title={getTitle()}
        isFavorite={false}
        showFavorite={false}
        textColor={theme.text}
        borderColor={theme.border}
      />

      <div className={styles.content}>
        <div
          className={styles.container}
          style={{ backgroundColor: theme.card }}
        >
          {isQsoil ? (
            <QsoilLegalityContent screen={currentScreen} />
          ) : (
            <LegalityContent screen={currentScreen} />
          )}
        </div>
      </div>
    </div>
  );
};
